import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { type CustomAxiosConfig, maxios } from '../../lib/maxios/maxios';
import { type ShopifyInstallUrlResponseDto } from '../../lib/types';

const ENDPOINT = 'verify_install_url';

export const fetchAppInstallUrl = async (storeId: string): Promise<string> => {
    const url = pathfinder('ai_store_builder_api_get', {
        version: 'v1',
        store_id: storeId,
        endpoint: ENDPOINT,
    });

    const options: Partial<CustomAxiosConfig> = {
        routeKey: ENDPOINT,
    };

    try {
        const { data } = await maxios.get<ShopifyInstallUrlResponseDto>(url, options);
        return data.installUrl;
    } catch (error) {
        logger.error(error as Error, {
            description: 'Failed to fetch app install url',
            store_id: storeId,
        });

        throw error;
    }
};
